import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsOverview = ({ metrics, onCreateIncident }) => {
  const metricCards = [
    {
      title: 'Active Incidents',
      value: metrics?.activeIncidents,
      icon: 'AlertTriangle',
      color: 'text-error',
      bgColor: 'bg-error/10',
      change: '+3 from yesterday',
      changeType: 'increase'
    },
    {
      title: 'SLA Breaches',
      value: metrics?.slaBreaches,
      icon: 'Clock',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      change: '-2 from yesterday',
      changeType: 'decrease'
    },
    {
      title: 'Resolved Today',
      value: metrics?.resolvedToday,
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10',
      change: '+8 from yesterday',
      changeType: 'increase'
    },
    {
      title: 'System Health',
      value: `${metrics?.systemHealth}%`,
      icon: 'Activity',
      color: metrics?.systemHealth >= 95 ? 'text-success' : metrics?.systemHealth >= 80 ? 'text-warning' : 'text-error',
      bgColor: metrics?.systemHealth >= 95 ? 'bg-success/10' : metrics?.systemHealth >= 80 ? 'bg-warning/10' : 'bg-error/10',
      change: 'All systems operational',
      changeType: 'stable'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {metricCards?.map((metric, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-6 shadow-light hover:shadow-medium transition-shadow duration-200">
          <div className="flex items-center justify-between mb-4">
            <div className={`p-3 rounded-lg ${metric?.bgColor}`}>
              <Icon name={metric?.icon} size={24} className={metric?.color} />
            </div>
            {index === 0 && (
              <button
                onClick={onCreateIncident}
                className="p-2 rounded-md hover:bg-muted transition-colors duration-200"
                title="Create New Incident"
              >
                <Icon name="Plus" size={20} className="text-primary" />
              </button>
            )}
          </div>
          
          <div className="space-y-2">
            <h3 className="text-sm font-medium text-muted-foreground">{metric?.title}</h3>
            <p className="text-2xl font-semibold text-foreground">{metric?.value}</p>
            <div className="flex items-center space-x-1">
              <Icon 
                name={metric?.changeType === 'increase' ? 'TrendingUp' : metric?.changeType === 'decrease' ? 'TrendingDown' : 'Minus'} 
                size={14} 
                className={
                  metric?.changeType === 'increase' ? 'text-error' : 
                  metric?.changeType === 'decrease'? 'text-success' : 'text-muted-foreground'
                } 
              />
              <span className="text-xs text-muted-foreground">{metric?.change}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MetricsOverview;